import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

export const ScorecardVendedor = () => {
  const location = useLocation();
  const history = useHistory();
  const [Cambio, setCambio] = useState([]);
  const [data, setData] = useState([]);
  const [nuevosDatos, setNuevosDatos] = useState([]);
  const nuevosDatosTemp = [...Cambio];
  const [ejercicio, setEjercicio] = useState("");
  var ejercicioActual;

  // Tracks whether last cell focus came from keyboard navigation (Excel behavior)
  const isKeyboardFocus = useRef(false);

  // Formats a raw numeric value with thousand separators for display only
  const formatearMiles = (val) => {
    if (val === "" || val === null || val === undefined) return "";
    const num = parseFloat(String(val).replace(/,/g, ""));
    if (isNaN(num)) return String(val);
    return num.toLocaleString("es-MX");
  };

  const onBack = () => {
    history.push("/Ventas/ScorecardObjetivoVendedores");
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const onhandleChangeEjercicio = (event) => {
    setEjercicio(event.target.value);
    ejercicioActual = event.target.value;
    console.log(ejercicioActual);
  };

  useEffect(() => {
    if (ejercicio === "") {
      const anioActual = new Date().getFullYear().toString();
      setEjercicio(anioActual);
    }

    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `CargaScorecardVendedor/MostrarScorecardVendedor?ejercicio=${ejercicio}&vendedor=${location.state.idempleado}`,
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
        setCambio(result);
        setNuevosDatos(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  }, [ejercicio]);

  const loadData = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `CargaScorecardVendedor/MostrarScorecardVendedor?ejercicio=${ejercicio}&vendedor=${location.state.idempleado}`,
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  };

  const onKeyDown = (event, index) => {
    if (event.key === "ArrowRight") {
      event.preventDefault();
      const nextCell =
        event.target.parentElement.nextElementSibling?.firstElementChild;
      if (nextCell) {
        isKeyboardFocus.current = true;
        nextCell.focus();
      }
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      const prevCell =
        event.target.parentElement.previousElementSibling?.firstElementChild;
      if (prevCell) {
        isKeyboardFocus.current = true;
        prevCell.focus();
      }
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      const currentTd = event.target.parentElement;
      const colIndex = Array.from(currentTd.parentElement.children).indexOf(currentTd);
      const nextRow = currentTd.closest("tr").nextElementSibling;
      if (nextRow) {
        const targetInput = nextRow.children[colIndex]?.querySelector("input");
        if (targetInput) {
          isKeyboardFocus.current = true;
          targetInput.focus();
        }
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      const currentTd = event.target.parentElement;
      const colIndex = Array.from(currentTd.parentElement.children).indexOf(currentTd);
      const prevRow = currentTd.closest("tr").previousElementSibling;
      if (prevRow) {
        const targetInput = prevRow.children[colIndex]?.querySelector("input");
        if (targetInput) {
          isKeyboardFocus.current = true;
          targetInput.focus();
        }
      }
    }
  };

  const onKeyDown2 = (event, index) => {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      const prevCell =
        event.target.parentElement.previousElementSibling?.firstElementChild;
      if (prevCell) {
        isKeyboardFocus.current = true;
        prevCell.focus();
      }
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      const currentTd = event.target.parentElement;
      const colIndex = Array.from(currentTd.parentElement.children).indexOf(currentTd);
      const nextRow = currentTd.closest("tr").nextElementSibling;
      if (nextRow) {
        const targetInput = nextRow.children[colIndex]?.querySelector("input");
        if (targetInput) {
          isKeyboardFocus.current = true;
          targetInput.focus();
        }
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      const currentTd = event.target.parentElement;
      const colIndex = Array.from(currentTd.parentElement.children).indexOf(currentTd);
      const prevRow = currentTd.closest("tr").previousElementSibling;
      if (prevRow) {
        const targetInput = prevRow.children[colIndex]?.querySelector("input");
        if (targetInput) {
          isKeyboardFocus.current = true;
          targetInput.focus();
        }
      }
    }
  };

  // Selects all text when cell was reached via keyboard — typing replaces the value (Excel behavior)
  const handleFocus = (event) => {
    if (isKeyboardFocus.current) {
      event.target.select();
      isKeyboardFocus.current = false;
    }
  };

  // Mouse click places the cursor without auto-selecting (normal edit mode)
  const handleInputClick = () => {
    isKeyboardFocus.current = false;
  };

  const handleChange = (event, index, fieldName) => {
    const input = event.target;
    const selectionStart = input.selectionStart;
    const currentValue = input.value;

    // Strip commas added by formatting and reject non-numeric characters
    const rawNew = currentValue.replace(/,/g, "").replace(/[^0-9.]/g, "");

    // Compute formatted string to calculate cursor offset caused by commas
    const formatted =
      rawNew !== "" ? parseFloat(rawNew).toLocaleString("es-MX") : "";
    const diff = formatted.length - currentValue.length;

    nuevosDatosTemp[index][fieldName] = rawNew;
    setCambio(nuevosDatosTemp);
    setNuevosDatos(nuevosDatosTemp);

    // Restore cursor position after React re-renders with the formatted value
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
        const newPos = Math.max(0, selectionStart + diff);
        input.setSelectionRange(newPos, newPos);
      }
    });
  };

  const onGuardar = () => {
    setLoader({ ...loader, mostrar: true });
    const mdl = {
      idproyeccion: -999,
      ejercicio: ejercicio,
      periodo: 12,
      sucursal: location.state.idSucursal,
      idvendedor: location.state.idempleado,
      idlinea: 1,
      objetivo: 0,
      unidades_vendidas: 0,
      objetivo_habilitado: 1,
      unidades_vendidas_habilitado: 1,
      scorecard_detalle: JSON.stringify(nuevosDatosTemp),
    };
    request
      .post(`GuardaScorecardVendedor/Guardar`, mdl)
      .then((response) => {
        console.log("enviado");
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        console.log(error);
        setLoader({ ...loader, mostrar: false });
      });
  };

  const onAprobar = () => {
    setLoader({ ...loader, mostrar: true });
    const mdl = {
      ejercicio: ejercicio,
      idvendedor: location.state.idempleado,
      // usuario: 8919,
    };

    request
      .post(`ApruebaScorecardObjetivo/Aprueba`, mdl)
      .then((response) => {
        console.log("enviado");
        // Después de aprobar, cargar los nuevos datos
        setLoader({ ...loader, mostrar: true }); // Mostrar el loader mientras se cargan los datos
        request
          .get(
            `CargaScorecardVendedor/MostrarScorecardVendedor?ejercicio=${ejercicio}&vendedor=${location.state.idempleado}`,
          )
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            setData(result);
            setCambio(result);
            setNuevosDatos(result); // Inicializar nuevosDatos con los datos cargados
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            console.error(
              "Error al cargar los datos después de aprobar:",
              error,
            );
          });
      })
      .catch((error) => {
        console.log(error);
        setLoader({ ...loader, mostrar: false });
      });
  };

  const onModificar = () => {
    setLoader({ ...loader, mostrar: true });
    const mdl = {
      ejercicio: ejercicio,
      idvendedor: location.state.idempleado,
      usuario: 8919,
    };

    request
      .post(`ApruebaScorecardObjetivo/Modifica`, mdl)
      .then((response) => {
        console.log("enviado");
        // Después de modificar, cargar los nuevos datos
        setLoader({ ...loader, mostrar: true }); // Mostrar el loader mientras se cargan los datos
        request
          .get(
            `CargaScorecardVendedor/MostrarScorecardVendedor?ejercicio=${ejercicio}&vendedor=${location.state.idempleado}`,
          )
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            setData(result);
            setCambio(result);
            setNuevosDatos(result); // Inicializar nuevosDatos con los datos cargados
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            console.error(
              "Error al cargar los datos después de modificar:",
              error,
            );
          });
      })
      .catch((error) => {
        console.log(error);
        setLoader({ ...loader, mostrar: false });
      });
  };
  return (
    <PlantillaScreen
      titulo={"SCORECARD OBJETIVO DE " + location.state.empleado.toUpperCase()}
      className_main={1}
      /* Clases -v2: corrigen el ancho de columnas y habilitan el scroll
         horizontal. Las clases anteriores siguen en _ScorecardVendedor.scss;
         para regresar a la versión previa quitar el sufijo "-v2" aquí, en
         .scorecard-vendedor-encabezado-v2 y en .scorecard-vendedor-tabla-v2. */
      className={"scorecard-vendedor-v2"}
    >
      <LoaderScreen loader={loader} />
      <div className="scorecard-vendedor-botones-pagina-container">
        <div
          className="scorecard-vendedor-actions-regresar"
          onClick={() => onBack()}
        >
          <ArrowBackIcon />
          Regresar
        </div>
      </div>
      {/* El scroll ya no vive aquí (por eso sale "scroll-4"), sino en
          .scorecard-vendedor-tabla-v2: un solo scroller evita que se rompa
          el encabezado sticky de la tabla. */}
      <div className="scorecard-vendedor-encabezado-v2">
        <div className="scorecard-vendedor-container">
          <div className="combobox-ejercicio">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Ejercicio</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="ejercicio"
                onChange={(event) => onhandleChangeEjercicio(event)}
                sx={{ height: 40 }}
                value={ejercicio}
              >
                <MenuItem value="2024">2024</MenuItem>
                <MenuItem value="2025">2025</MenuItem>
                <MenuItem value="2026">2026</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="scorecard-vendedor-tabla-v2 scroll-4">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>ID de Línea</th>
                  <th>
                    <div>Línea</div>
                  </th>
                  <th>
                    <div>Enero</div>
                  </th>
                  <th>
                    <div>Febrero</div>
                  </th>
                  <th>
                    <div>Marzo</div>
                  </th>
                  <th>
                    <div>Abril</div>
                  </th>
                  <th>
                    <div>Mayo</div>
                  </th>
                  <th>
                    <div>Junio</div>
                  </th>
                  <th>
                    <div>Julio</div>
                  </th>
                  <th>
                    <div>Agosto</div>
                  </th>
                  <th>
                    <div>Septiembre</div>
                  </th>
                  <th>
                    <div>Octubre</div>
                  </th>
                  <th>
                    <div>Noviembre</div>
                  </th>
                  <th>
                    <div>Diciembre</div>
                  </th>
                  <th>
                    <div>Total</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Renglones de unidades — excluye Refacciones (idlinea 14) */}
                {data.map((item, index) => {
                  if (item.idlinea === 14) return null;

                  const total = [
                    item.enero, item.febrero, item.marzo, item.abril,
                    item.mayo, item.junio, item.julio, item.agosto,
                    item.septiembre, item.octubre, item.noviembre, item.diciembre,
                  ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);

                  return (
                    <tr key={index}>
                      <td className="columna-centrada">{item.idlinea}</td>
                      <td>{item.linea}</td>
                      <td className="columna-centrada" tabIndex={index * 14 + 1}>
                        <input type="text" value={formatearMiles(item.enero)}
                          onChange={(event) => handleChange(event, index, "enero")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 2}>
                        <input type="text" value={formatearMiles(item.febrero)}
                          onChange={(event) => handleChange(event, index, "febrero")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 3}>
                        <input type="text" value={formatearMiles(item.marzo)}
                          onChange={(event) => handleChange(event, index, "marzo")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 4}>
                        <input type="text" value={formatearMiles(item.abril)}
                          onChange={(event) => handleChange(event, index, "abril")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 5}>
                        <input type="text" value={formatearMiles(item.mayo)}
                          onChange={(event) => handleChange(event, index, "mayo")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 6}>
                        <input type="text" value={formatearMiles(item.junio)}
                          onChange={(event) => handleChange(event, index, "junio")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 7}>
                        <input type="text" value={formatearMiles(item.julio)}
                          onChange={(event) => handleChange(event, index, "julio")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 8}>
                        <input type="text" value={formatearMiles(item.agosto)}
                          onChange={(event) => handleChange(event, index, "agosto")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 9}>
                        <input type="text" value={formatearMiles(item.septiembre)}
                          onChange={(event) => handleChange(event, index, "septiembre")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 10}>
                        <input type="text" value={formatearMiles(item.octubre)}
                          onChange={(event) => handleChange(event, index, "octubre")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 11}>
                        <input type="text" value={formatearMiles(item.noviembre)}
                          onChange={(event) => handleChange(event, index, "noviembre")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 12}>
                        <input type="text" value={formatearMiles(item.diciembre)}
                          onChange={(event) => handleChange(event, index, "diciembre")}
                          onKeyDown={(event) => onKeyDown2(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada total">{formatearMiles(total)}</td>
                    </tr>
                  );
                })}

                {/* TOTALES — suma solo renglones de unidades (excluye idlinea 14) */}
                <tr>
                  <td colSpan={2} className="columna-derecha total">
                    TOTALES:{" "}
                  </td>
                  {[
                    "enero", "febrero", "marzo", "abril", "mayo", "junio",
                    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
                  ].map((mes) => {
                    const totalMes = data
                      .filter((item) => item.idlinea !== 14)
                      .reduce((acc, item) => acc + (parseFloat(item[mes]) || 0), 0);
                    return (
                      <td key={mes} className="columna-centrada total">
                        {formatearMiles(totalMes)}
                      </td>
                    );
                  })}
                  <td className="columna-centrada total">
                    {formatearMiles(
                      data
                        .filter((item) => item.idlinea !== 14)
                        .reduce(
                          (acc, item) =>
                            acc +
                            (parseFloat(item.enero) || 0) +
                            (parseFloat(item.febrero) || 0) +
                            (parseFloat(item.marzo) || 0) +
                            (parseFloat(item.abril) || 0) +
                            (parseFloat(item.mayo) || 0) +
                            (parseFloat(item.junio) || 0) +
                            (parseFloat(item.julio) || 0) +
                            (parseFloat(item.agosto) || 0) +
                            (parseFloat(item.septiembre) || 0) +
                            (parseFloat(item.octubre) || 0) +
                            (parseFloat(item.noviembre) || 0) +
                            (parseFloat(item.diciembre) || 0),
                          0,
                        ),
                    )}
                  </td>
                </tr>

                {/* Refacciones (idlinea 14) — importe, debajo de TOTALES */}
                {data.map((item, index) => {
                  if (item.idlinea !== 14) return null;

                  const total = [
                    item.enero, item.febrero, item.marzo, item.abril,
                    item.mayo, item.junio, item.julio, item.agosto,
                    item.septiembre, item.octubre, item.noviembre, item.diciembre,
                  ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);

                  return (
                    <tr key={index}>
                      <td className="columna-centrada">{item.idlinea}</td>
                      <td>{item.linea}</td>
                      <td className="columna-centrada" tabIndex={index * 14 + 1}>
                        <input type="text" value={formatearMiles(item.enero)}
                          onChange={(event) => handleChange(event, index, "enero")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 2}>
                        <input type="text" value={formatearMiles(item.febrero)}
                          onChange={(event) => handleChange(event, index, "febrero")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 3}>
                        <input type="text" value={formatearMiles(item.marzo)}
                          onChange={(event) => handleChange(event, index, "marzo")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 4}>
                        <input type="text" value={formatearMiles(item.abril)}
                          onChange={(event) => handleChange(event, index, "abril")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 5}>
                        <input type="text" value={formatearMiles(item.mayo)}
                          onChange={(event) => handleChange(event, index, "mayo")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 6}>
                        <input type="text" value={formatearMiles(item.junio)}
                          onChange={(event) => handleChange(event, index, "junio")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 7}>
                        <input type="text" value={formatearMiles(item.julio)}
                          onChange={(event) => handleChange(event, index, "julio")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 8}>
                        <input type="text" value={formatearMiles(item.agosto)}
                          onChange={(event) => handleChange(event, index, "agosto")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 9}>
                        <input type="text" value={formatearMiles(item.septiembre)}
                          onChange={(event) => handleChange(event, index, "septiembre")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 10}>
                        <input type="text" value={formatearMiles(item.octubre)}
                          onChange={(event) => handleChange(event, index, "octubre")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 11}>
                        <input type="text" value={formatearMiles(item.noviembre)}
                          onChange={(event) => handleChange(event, index, "noviembre")}
                          onKeyDown={(event) => onKeyDown(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada" tabIndex={index * 14 + 12}>
                        <input type="text" value={formatearMiles(item.diciembre)}
                          onChange={(event) => handleChange(event, index, "diciembre")}
                          onKeyDown={(event) => onKeyDown2(event, index)}
                          onFocus={handleFocus} onClick={handleInputClick} />
                      </td>
                      <td className="columna-centrada total">{formatearMiles(total)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="boton-guardar-cambios-container">
            <button
              onClick={() => onGuardar()}
              className="scorecard-guardar-container-button-btn"
            >
              <SaveIcon />
              Guardar
            </button>
          </div>
          {/* <div className='scorecard-modificar-container-button-footer'>
            {data.some(item => item.objetivo_habilitado === 1) && (
              <button onClick={() => onModificar()} className='scorecard-modificar-container-button-btn'>
                <EditIcon />
                Modificar
              </button>
            )}
          </div> */}
          <div>
            {/* {data.some(item => item.objetivo_habilitado === 0) && (
            <div>
              <div className='scorecard-aprobar-container-button-footer'>
                <button onClick={() => onAprobar()} className='scorecard-aprobar-container-button-btn'>
                  <CheckBoxIcon />
                  Aprobar
                </button>
              </div>
              <div className='scorecard-guardar-container-button-footer'>
                <button onClick={() => onGuardar()} className='scorecard-guardar-container-button-btn'>
                  <SaveIcon />
                  Guardar
                </button>
              </div>
            </div>
          )} */}
          </div>
          {/* <div className="back" onClick={() => onBack()}>
          <ArrowBackIcon /> Regresar
        </div> */}
        </div>
      </div>
    </PlantillaScreen>
  );
};
